import BaseViz from './BaseViz'
import TreemapChart from '../charts/TreemapChart'
import PieDataController from '../viz_behaviors/TreemapDataController'
export default class TreemapViz extends BaseViz {
  static chartClass = TreemapChart
  static dataControllerClass = PieDataController
  static defaultConfig = {
    LegendBehavior: {
      showLegend: {
        value: false,
        nonEditable: true,
      },
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
      },
      colorKey: 'id',
      // colorScale: {
      //   value: {
      //     scaleSteps: 5,
      //     interpolationType: 'linear',
      //     scaleOption: 'gradient',
      //     opacityMapValue: 100,
      //     colorRange: ['#BBD6E8', '#15537E'],
      //     customSteps: null,
      //   },
      // },
      // colorKey: 'value',
    },
    valueFormat: {
      type: [String, Array, Function, null],
      default: null,
    },
    unit: {
      type: [String, Boolean, null],
      default: false,
    },
  }
}
